import React from 'react';
import Radio from '@material-ui/core/Radio/Radio';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import { grayBackgroundColor } from './styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import listBulletIcon from '../../../assets/list-bullet-icon.svg';

interface DoneeTypeCardProps {
    imgSrc: string;
    alt: string;
    checked: boolean;
    heading: string;
    pointList: string[];
    style?: CSSProperties;
    className?: string;
    onClick: () => unknown;
    radioId?: string;
}

const useStyles = makeStyles((theme: Theme) => {
    const spacing3 = theme.spacing(3);
    const spacing4 = theme.spacing(4);
    return createStyles({
        cardStyles: {
            cursor: 'pointer',
            boxShadow: '0px 0px 8px rgba(131, 131, 131, 0.4)',
            borderRadius: 10,
            width: 425,
            height: '100%',
            '& .section': {
                padding: '24px 40px 0 40px',
            },
            '& .heading': {
                fontSize: 22,
                fontWeight: 'bold',
                marginLeft: spacing4,
                textAlign: 'left',
            },
            '& .top-section': {
                display: 'flex',
                alignItems: 'center',
            },
            '& .radio': {
                textAlign: 'center',
                borderRadius: '0px 0px 10px 10px',
                paddingTop: spacing3,
                paddingBottom: spacing3,
                backgroundColor: grayBackgroundColor,
            },
            '& .MuiRadio-root': {
                color: theme.palette.primary.main,
            },
            '& .MuiIconButton-root': {
                padding: 0,
                backgroundColor: '#fff',
            },
            '@media (max-width:450px)': {
                width: '100%',
            },
        },
        points: {
            textAlign: 'left',
            fontSize: 16,
            marginTop: spacing4,
            marginBottom: spacing4,
            '& ul': {
                color: '#73717F',
                paddingLeft: spacing3,
                listStyleImage: `url(${listBulletIcon})`,
            },
            '& li': {
                paddingLeft: 10,
                marginBottom: spacing3,
            },
        },
        selected: {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    });
});

const DoneeTypeCard: React.FC<DoneeTypeCardProps> = ({
    onClick,
    imgSrc,
    alt,
    checked,
    heading,
    pointList,
    style,
    className,
    radioId,
}) => {
    const { cardStyles, points, selected } = useStyles();
    return (
        <div
            onClick={onClick}
            style={style}
            className={`${cardStyles} ${className} ${checked ? selected : ''}`}
        >
            <div className="section">
                <div className="top-section">
                    <img src={imgSrc} alt={alt} title={alt} />
                    <div className="heading">{heading}</div>
                </div>
                <div className={points}>
                    <ul>
                        {pointList.map((p, i) => (
                            <li key={i}>{p}</li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="radio">
                <Radio id={radioId} checked={checked} />
            </div>
        </div>
    );
};

export default DoneeTypeCard;
